import React,{useState ,useEffect} from 'react';
import { MapPinIcon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';
import BoxOne from '../../assets/images/boxOne.webp';
import BoxTwo from '../../assets/images/boxTwo.webp';
import { useTranslation } from 'react-i18next';
import useLanguageDirection from '../../hooks/useLanguageDirection';

const CustomContactUsCard =({FlagImage,title,Email,phoneNumberOne ,phoneNumberTwo,phoneNumberThree,Location,visible ,Link})=>{
    const { t ,i18n} = useTranslation();  
   const direction = useLanguageDirection();

    return (
        <div className="flex items-center justify-center w-full" >
      <div className="flex items-center w-full">
     
        {/* Title Section */}
        <div className="bg-white shadow-lg h-[300px] md:h-[400px] 
         px-4 py-8 flex flex-col justify-between w-full" >
          <div className='flex flex-col items-center justify-center mb-4 md:mb-0'>
            <img
              src={FlagImage}
              alt='flag'
              className='w-20 '  // Add bottom margin to space the image from the title
            />
            <div className='w-1/2 px-1 py-1 text-center bg-custom-yellow md:px-2 md:py-2'>
              <h2 className="text-lg text-black md:text-2xl ">{title}</h2>
            </div>
          </div>

          <p className="flex items-center text-sm text-gray-500">
            <EnvelopeIcon className="w-4 h-4 me-2 text-custom-yellow" />
              <a href="mailto:support@markaship.com" className="text-gray-500 hover:underline">{Email}</a>
          </p>
          <p className="flex items-center text-sm text-gray-500">
            <PhoneIcon className={`h-4 w-4 me-2 text-custom-yellow ${direction === "rtl"?"rotate-[270deg]" :""}`} />

              <a href={`tel:${phoneNumberOne}`} className="text-gray-500 hover:underline" dir="ltr">{phoneNumberOne}</a>
          </p>
          {visible && (
                  <div className="h-auto transition-all duration-300 opacity-100">
                    <p className="flex items-center text-sm text-gray-700">
                      <PhoneIcon className={`h-5 w-5 me-2 text-custom-yellow ${direction === "rtl"?"rotate-[270deg]" :""}`} />
                      <a
                        href={`tel:${phoneNumberTwo}`}
                        className="text-gray-700 hover:underline" dir='ltr'
                      >
                        {phoneNumberTwo}
                      </a>
                    </p>
                  </div>
          )}
                
          <p className="flex items-center text-sm text-gray-500">
          <MapPinIcon className="w-4 h-4 me-2 text-custom-yellow" />

            <a
              href={Link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:underline"
            >
            {Location}
            </a>
          </p>
        </div>

      </div>
    </div>
    )
}

export default CustomContactUsCard;